import { Component } from '@angular/core';

import { SpecificComponent } from '../specific.component';
import { BckpJobSearchResult } from 'src/app/_common/models/search-result';

@Component({
    selector: 'aa-search-result-bckp-job',
    templateUrl: './bckp-job.component.html',
    styleUrls: [
        '../specific-shared.scss',
        '../../../../../../customer/bckp/jobs/jobs-list/columns-shared.scss',
        './bckp-job.component.scss'
    ],
    standalone: false
})
export class BckpJobComponent extends SpecificComponent<BckpJobSearchResult>
{
    constructor()
    {
        super();
    }
}
